module.exports = __webpack_public_path__ + "static/media/ic-max-grey.5aec59eb.svg";